import { createSlice } from '@reduxjs/toolkit';
import ApiLocalStorage from './ApiLocalStorage';

const getLegacyJson = (key, fallbackValue) => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return fallbackValue;
  }

  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallbackValue;
  } catch {
    return fallbackValue;
  }
};

const clearLegacySessionStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) return;

  localStorage.removeItem('user');
};

const initialState = {
  currentUser: getLegacyJson('user', null),

  deviceKey:
    typeof window !== 'undefined'
      ? localStorage.getItem('deviceKey') || ''
      : '',
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCurrentUserState: (state, action) => {
      state.currentUser = action.payload;
    },

    setDeviceKeyState: (state, action) => {
      state.deviceKey = action.payload;
    },
    clearSessionState: (state) => {
      state.currentUser = null;
    },
  },
});

export const {
  setCurrentUserState,
  setDeviceKeyState,
  clearSessionState,
} = appSlice.actions;

export const setCurrentUser = setCurrentUserState;
export const clearCurrentUser = () => setCurrentUserState(null);

export const setDeviceKey = setDeviceKeyState;
export const clearSession = () => (dispatch) => {
  clearLegacySessionStorage();
  ApiLocalStorage.removeItem(ApiLocalStorage.TEMP_REMEMBER_ME);
  dispatch(clearSessionState());
};

export default appSlice.reducer;
